import React, {Component} from "react";
import BilateralBidAdminView from "./BilateralBidAdminView";
import {BilateralBidService} from "../../../service/bilateral/bid/BilateralBidService";
import ContextMenu from "../../../components/contextMenu";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {
    BILATERAL_BID_ADMIN_ROUTE,
    ADD_BILATERAL_BID_ADMIN_ROUTE,
    EDIT_BILATERAL_BID_ADMIN_ROUTE,
    TAKE_BILATERAL_BID_ADMIN_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";

export default class BilateralBidAdminContainer extends Component {
    constructor(props) {
        super(props)
        this.bilateralBidService = new BilateralBidService();
        this.setConfirmationRef = element => {
            this.confirmationRef = element
        }
        this.state = {
            source: true,
            isLoading: true,
            dataBidAdmin:[]
        };

        this.loading = this.loading.bind(this);
        this.getDataBidAdmin = this.getDataBidAdmin.bind(this);
        this.bilateralBidAdminActionTemplate = this.bilateralBidAdminActionTemplate.bind(this);
        this.redirectTakeBidAdmin = this.redirectTakeBidAdmin.bind(this);
        this.redirectEditBidAdmin = this.redirectEditBidAdmin.bind(this);
        this.redirectAddBidAdmin = this.redirectAddBidAdmin.bind(this);
        this.deleteBidAdmin = this.deleteBidAdmin.bind(this);
        this.onChangeSource = this.onChangeSource.bind(this);
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }
    /**
     * Función que consume el BilateralContract y obtiene la información
     * sobre los contratos.
     * @returns {Promise<void>}
     */
    getDataBidAdmin() {
        this.loading(true)
        let source = this.state.source === true ? "ADMINISTRATIVE" : "CLIENT"
        return this.bilateralBidService.getBilateralBidAdmin(source)
            .then(res => {
                if (this.validResponse(res)){
                    this.setState({
                        dataBidAdmin: this.reformatResponseList(res.data),
                    })
                }
                this.loading(false);
            })
    }

    reformatResponseList(responseList){
        return responseList.map((bid) => (
            {
                lenderShortName: bid.lenderShortName,
                borrowerShortName: bid.borrowerShortName,
                status: bid.status,
                id: bid.base.id,
                account: bid.base.account,
                composeName: bid.base.composeName,
                rate: bid.base.rate,
                todayPrice: bid.base.todayPrice,
                titles: bid.base.titles,
                amount: bid.base.amount,
            }
        ));
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({sticky: true, severity: 'error', summary: 'Error.',
                detail: res.message  + ' ' + res.debugMessage});
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.getDataBidAdmin();
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    /**
     * Función que realiza el template de la última columna de la tabla, donde se
     * muestra un botón para editar el elemento.
     * @param rowData Valor del renglón
     * @param column Valor de la columna
     * @returns {html} Template del botón editar.
     */
    bilateralBidAdminActionTemplate(rowData, column) {
        let optionsMenu = [
            {label: "Editar", action: () => this.redirectEditBidAdmin(rowData,false)},
            {label: "Tomar", action: () => this.redirectTakeBidAdmin(rowData,false)},
            {label: "Eliminar", action: this.confirmationRef.openConfirmationMessage},
        ];
        return (
            <ContextMenu menuOptions = {optionsMenu}/>
        );
    }

    /**
     * Función que redirecciona a la pantalla de editar la postura seleccionada
     * Se envía la postura y la ruta a la que tiene que que regresar.
     * @param rowData Elemento que trae la información del objeto a editar.
     */
    redirectEditBidAdmin(rowData) {
        this.props.history.push({
            pathname: EDIT_BILATERAL_BID_ADMIN_ROUTE,
            state: {
                returnPath: BILATERAL_BID_ADMIN_ROUTE,
                orderSelected: rowData,
            },
        });
    }

    /**
     * Función que redirecciona a la pantalla de tomar postura
     * Se envían los datos de la postura y la ruta a la que tiene que que regresar.
     * @param rowData Elemento que trae la información del objeto a editar.
     */
    redirectTakeBidAdmin(rowData) {
        this.props.history.push({
            pathname: TAKE_BILATERAL_BID_ADMIN_ROUTE,
            state: {
                returnPath: BILATERAL_BID_ADMIN_ROUTE,
                orderSelected: rowData,
            },
        });
    }
    redirectAddBidAdmin(){
        this.props.history.push({
            pathname: ADD_BILATERAL_BID_ADMIN_ROUTE,
            state: {
                returnPath: BILATERAL_BID_ADMIN_ROUTE,

            },
        });

    }
    deleteBidAdmin(){

    }
    onChangeSource(event) {
        this.setState({
            source: event.target.checked,
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>
        this.confMsg = <ConfirmationMessage ref={this.setConfirmationRef}
                                            invisible={true}
                                            legend="¿Desea eliminar la postura seleccionada?"
                                            action={this.deleteBidAdmin}/>;
        return <BilateralBidAdminView
            messagesGrowl={messagesGrowl}
            confirmationMsg={this.confMsg}
            isLoading={this.state.isLoading}
            dataBidAdmin = {this.state.dataBidAdmin}
            source={this.state.source}
            getDataBidAdmin={this.getDataBidAdmin}
            redirectAddBidAdmin={this.redirectAddBidAdmin}
            bilateralBidAdminActionTemplate = {this.bilateralBidAdminActionTemplate}
            onChangeSource = {this.onChangeSource}
        />
    }
}

BilateralBidAdminContainer.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
};